import { HostedButtonDetails, OptionDetail } from '@client/typings/Common';
import { ButtonConfig, Variant } from '@components/buttons/types';
// We want to prefix this to the field name before we hash it
// so that we can differentiate between variant inputs and other inputs
// in case the variant is named the same as our other input names
const INTERNAL_VARIANT_NAME_PREFIX = 'NOCODE_VARIANT_';

export const getVariantFieldName = (name: string) => `${INTERNAL_VARIANT_NAME_PREFIX}${name}`;

export const getVariantNames = (optionDetails: HostedButtonDetails['option_details']) =>
  optionDetails?.map((option) => option.name) || [];

type VariantDetails = {
  variant_name: string;
  option_count: number;
  has_image?: boolean;
  has_price?: boolean;
};

const isEditorVariant = (option: Variant | OptionDetail): option is Variant =>
  'variantName' in option;

const getVariantInfo = (option: Variant | OptionDetail) =>
  isEditorVariant(option)
    ? { variantName: option.variantName, variantOptions: option.variantOptions }
    : { variantName: option.name, variantOptions: option.selection_details };

// Primarily being used for FPTI
export const getVariantDetails = (
  optionDetails: HostedButtonDetails['option_details'] | ButtonConfig['variants']
) => {
  const variantDetails: Record<string, VariantDetails> = {};
  optionDetails?.forEach((option, index) => {
    const key = `variant_${index + 1}`;
    const { variantName, variantOptions } = getVariantInfo(option);
    const optionCount = variantOptions?.length || 0;
    const firstVariantDetails =
      index === 0
        ? {
            has_image: variantOptions?.some((variant_option) => !!variant_option.images) || false,
            has_price: variantOptions?.some((variant_option) => !!variant_option.price) || false
          }
        : {};
    variantDetails[key] = {
      variant_name: variantName,
      option_count: optionCount,
      ...firstVariantDetails
    };
  });
  return variantDetails;
};
